import { createFileRoute } from "@tanstack/react-router";
import { MemoryHome } from "@/pages/3d/memory/MemoryHome";

export const Route = createFileRoute("/demo/3d/memory/")({
  component: MemoryHome,
});
